
  import { css } from 'lit';
  export const styles = css`:host{--header-title-color: var(--ig-expansion-panel-header-title-color, var(--ig-gray-800));--ig-theme: bootstrap;--ig-theme-variant: light}`;
  